import { ORDER_STATUS } from '@/entities/order/model/orderStatus'

const BY_BACKEND_STATUS = {
  CREATED: ORDER_STATUS.NEW,
  PAYMENT_PENDING: ORDER_STATUS.PAYMENT_PENDING,
  PAID: ORDER_STATUS.NEW,
  ACCEPTED_BY_KITCHEN: ORDER_STATUS.PREPARING,
  COOKING: ORDER_STATUS.PREPARING,
  READY: ORDER_STATUS.READY_FOR_PICKUP,
  DISPATCHING: ORDER_STATUS.COURIER_ASSIGNED,
  COURIER_ASSIGNED: ORDER_STATUS.COURIER_ASSIGNED,
  PICKED_UP: ORDER_STATUS.PICKED_UP,
  DELIVERED: ORDER_STATUS.DELIVERED,
  COMPLETED: ORDER_STATUS.DELIVERED,
  CANCELLED: ORDER_STATUS.CANCELLED,
}

export function normalizeOrderStatus(status) {
  const key = typeof status === 'string' ? status.toUpperCase() : ''
  const normalized = BY_BACKEND_STATUS[key] ?? (typeof status === 'string' ? status.toLowerCase() : '')
  return normalized || ORDER_STATUS.NEW
}
